import React, { useContext, useEffect, useRef, useState } from "react";
import "../../styles/fonts.css";
import UploadForm from "./UploadForm";
//import "../upload/upload.css";
const UploadNonAcademic = (props) => {
  const [info, setInfo] = useState({
    name: "",
    description: "",
    author: "",
    type: "",
    resourcetype: "not approved",
    tags: [],
  });

  const newTag = useRef("");
  const { name, description, tags, author } = info;
  const onChange = (e) => {
    setInfo({ ...info, [e.target.name]: e.target.value });
  };
  const setUrl = (url) => {
    setInfo({ ...info, url });
  };
  const addTag = (e) => {
    let inp = e.target.value;
    let lastChar = inp.substring(inp.length - 1);
    console.log(lastChar);
    if (lastChar === " ") {
      inp = inp.slice(0, -1);
      setInfo({ ...info, tags: [...tags, inp] });
      newTag.current.value = "";
    }
  };
  const setType = (type) => {
    setInfo({ ...info, type });
  };
  const setResourceType = (resourcetype) => {
    setInfo({ ...info, resourcetype });
  };
  const deleteTag = (e) => {
    tags.splice(e.target.name, 1);
    setInfo({ ...info, tags: tags });
  };
  const onSubmit = async () => {
    const res = await props.addToFirestore(info, "extracurriculars");
    setInfo({
      name: "",
      description: "",
      author: "",
      type: "",
      resourcetype: "not approved",
      tags: [],
    });
  };
  return (
    <div className='App m-2 p-2 mx-auto'>
      <div className='title row'>
        <h2 className='m-2 text-center upperfont col-12'>Upload Here</h2>
        <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='exampleVideoTags'>Title</label>
          <input
            type='name'
            className='form-control simplefont text-center'
            id='name'
            name='name'
            value={name}
            placeholder='title'
            onChange={onChange}
            required
          />
        </div>
        <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='exampleVideoTags'>Author</label>
          <input
            type='text'
            className='form-control simplefont text-center'
            id='author'
            name='author'
            value={author}
            placeholder='Video Made/Presented by...'
            onChange={onChange}
            required
          />
        </div>
        <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto row'>
          <label htmlFor='description' className='text-center col-12'>
            Tags
          </label>

          {tags &&
            tags.map((item, index) => (
              <input
                type='button'
                name={index}
                value={item}
                className='fontcool col-2 bg-dark rounded-pill text-light mx-auto'
                aria-label='Close'
                onClick={deleteTag}
              />
            ))}

          <div className='input-group mb-3'>
            <input
              ref={newTag}
              onChange={addTag}
              className='form-control simplefont text-center'
              type='text'
              placeholder='Add tags and press space'
            />{" "}
          </div>
        </div>
        <div className='form-group col-11 m-2 text-center titlefont size09 mx-auto'>
          <label htmlFor='exampleVideoTags'>Description</label>
          <textarea
            type='description'
            className='form-control simplefont text-center'
            id='description'
            name='description'
            rows='3'
            value={description}
            placeholder='description'
            onChange={onChange}
          ></textarea>
        </div>
      </div>
      <UploadForm
        info={info}
        collection='extracurriculars'
        setUrl={setUrl}
        setType={setType}
        setResourceType={setResourceType}
      />
      <a href='#' className='nolinklook' onClick={onSubmit}>
        <button className='slantfont btn btn-block size09 btn-outline-success  mx-auto my-4'>
          UPLOAD
        </button>
      </a>
    </div>
  );
};

export default UploadNonAcademic;
